// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__OTBGe","icon":"LogoutButton_icon__UpOk1"};